import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyModel } from 'common/models/page-models/internship-company/internship-company/internship-company-data.model';
import { CompanyListingModel } from 'common/models/page-models/internship-company/internship-company/internship-company-grid.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { CompanyGridWidgetService } from 'common/widget/internship-company/company-grid-widget.service';


@Injectable({
    providedIn: 'root'
})
export class CompanyGridResolver extends GridResolver<CompanyModel, CompanyListingModel> {
    constructor(
        protected fs: CompanyGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
